// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"Inbound_imageContainer__T30Qa","formContainer":"Inbound_formContainer__aEcv_"};